<template>
  <footer class="footer has-cards">
    <div class="container">
      <hr />
      <div class="row align-items-center justify-content-md-between">
        <div class="col-md-6">
          <div class="copyright">
            &copy; 2019
            <a
              href="https://api.whatsapp.com/send?phone=22940361453"
              target="_blank"
              rel="noopener"
              >Panneau Mobile</a
            >
          </div>
        </div>
        <!--  -->
        <div class="col-md-6">
          <ul class="nav nav-footer justify-content-end">
            <li class="nav-item">
              <span class="nav-link">
                Powered by
                <a href="https://tok-services.web.app" target="_blank" rel="noopener">TOK SERVICES</a>
              </span>
            </li>
          </ul>
        </div>
        <!--  -->
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  name: "app-footer",
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
};
</script>
<style></style>
